<template>
  <section class="signup-landing">
    <div class="stars"></div>
    <div class="twinkling"></div>
    <div class="clouds"></div>  
    <svg id="Background" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1920 591.13"><defs><linearGradient id="GradientFill_12" x1="20.29" y1="362.62" x2="21.95" y2="458.12" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#e07d26"/><stop offset="1" stop-color="#f58b1f"/></linearGradient></defs><path d="M1920,116.51C1664.67,76.6,1340.24,52.72,987.1,52.72,608.47,52.72,262.84,80.17,0,125.4V559.27C262.84,604.5,608.47,632,987.1,632c353.14,0,677.57-23.89,932.9-63.8Z" transform="translate(0 -52.72)" style="fill:#c1276a;fill-rule:evenodd;opacity:0.15"/><path d="M408.55,615.79a77.4,77.4,0,1,0-130.69,0Z" transform="translate(0 -52.72)" style="fill:#d81f2a;fill-rule:evenodd;opacity:0.33"/><path d="M393.62,615.79a66.52,66.52,0,1,0-100.83,0Z" transform="translate(0 -52.72)" style="fill:#b5101b;fill-rule:evenodd"/><path d="M402.45,558.22c-10.07-31.46-54.39-51.33-78.67-25.81-12.83,13.5-12.29,35.85,6.9,43.14,6.24,2.37-4.34,2,3.37,2.61,15.41,1.21,21.07-13.82,19.33-27.18-1.68-13,22.29-1.58,25.27,25.31.78,7-3.16,11.7-8.12,3.21-1-1.63-6.14-10.73-9.16-8.38-1.22,1,3.26,9.9,4,12.68,2.12,7.9,3.2,17.63,15.18,10,2.59-1.64,11-9.86,3.7-.81-8.11,10.09-21.63,14.89-32.29,5.35-10.9-9.76-21.93-2.55-41.64-23.53-6.84-7.28-14.53-15.37-16,1.26-2.42,28.17,28.82,37,51.13,38.37,31.51,2,60.11-22.07,51.76-54.14-9-34.39-55.88-52.74-76.44-19.39,13.78-26.21,47.44-21.42,66.27-2.56,7.7,7.71,11.27,13.82,15.18,23.89C404.82,568.82,402.53,558.57,402.45,558.22Z" transform="translate(0 -52.72)" style="fill:#d81f2a;fill-rule:evenodd"/><path d="M1920,239.64a207.71,207.71,0,0,0-70.17-12.13c-115,0-208.16,93.2-208.16,208.17s93.2,208.16,208.16,208.16A207.71,207.71,0,0,0,1920,631.71Z" transform="translate(0 -52.72)" style="fill:#052830;fill-rule:evenodd;opacity:0.31"/><path id="planet" d="M1920,326.78a129.53,129.53,0,1,0,0,217.8Z" transform="translate(0 -52.72)" style="fill:#052830;fill-rule:evenodd;opacity:0.5"/><path d="M1920,365a104.88,104.88,0,1,0,0,138.35Z" transform="translate(0 -52.72)" style="fill:#0f5d70;fill-rule:evenodd"/><path d="M1904.21,496.79c26-51.37-10.88-97-56.84-73.49-7,3.61-28.17,9.86-12.3,11.19,13,1.09,47.76-23.19,64.57,14.05,8.29,18.37-4.33,49.4-3.13,27.62,2.07-37.47-34.34-47.73-24-29.92,40.17,69.24-95,92.1-109.29-7.83-6-42,26.76-93.54,19.87-58.74-17,85.61,59.11,89.36,34.79,65.88-16.83-16.25-13.75-38.65-13-60,.47-14.08,67.17-40.29,19.52-37.46-17.66,1-16.81-15.21-43,18.31-57.05,73.13,11.2,180.14,89.66,138.58,8.58-4.55-7.7,14.35-42.71,17.13-20.3,1.61,37.62,21.52,70.38-17.91Z" transform="translate(0 -52.72)" style="fill:#15a1c1;fill-rule:evenodd;opacity:0.5"/><path d="M148.34,410.8A168.6,168.6,0,0,0,0,243.44V284A129.83,129.83,0,0,1,129.83,413.82,129.83,129.83,0,0,1,0,543.65v34.51A168.6,168.6,0,0,0,148.34,410.8Z" transform="translate(0 -52.72)" style="fill:#f58b1f;opacity:0.1"/><path d="M43.06,410.8A46.51,46.51,0,0,1,0,457.08v86.57A129.83,129.83,0,0,0,129.83,413.82,129.83,129.83,0,0,0,0,284v80.53A46.52,46.52,0,0,1,43.06,410.8Z" transform="translate(0 -52.72)" style="fill:#f58b1f;opacity:0.1"/><path d="M43.06,410.8A46.51,46.51,0,0,1,0,457.08v86.57A129.83,129.83,0,0,0,129.83,413.82,129.83,129.83,0,0,0,0,284v80.53A46.52,46.52,0,0,1,43.06,410.8Z" transform="translate(0 -52.72)" style="fill:#e07d26;opacity:0.4"/><path d="M43.06,410.8A46.52,46.52,0,0,0,0,364.52v92.56A46.51,46.51,0,0,0,43.06,410.8Z" transform="translate(0 -52.72)" style="fill:#f58b1f;opacity:0.1"/><path d="M43.06,410.8A46.52,46.52,0,0,0,0,364.52v92.56A46.51,46.51,0,0,0,43.06,410.8Z" transform="translate(0 -52.72)" style="fill:#e07d26;opacity:0.4"/><path d="M43.06,410.8A46.52,46.52,0,0,0,0,364.52v92.56A46.51,46.51,0,0,0,43.06,410.8Z" transform="translate(0 -52.72)" style="fill:url(#GradientFill_12)"/></svg>             
    <svg id="Foreground" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1920 412.16">
      <defs><linearGradient id="linear-gradient" x1="933.59" y1="108.82" x2="983.22" y2="108.82" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#c8c8c8"/><stop offset="1" stop-color="#bcbcbc"/></linearGradient></defs>
      <path d="M13.14,630.5,0,666.45V715a96.33,96.33,0,0,0,5.47-12l20.64-54.47H861.44l1-18Z" transform="translate(0 -489.28)" style="fill:#b22025;fill-rule:evenodd"/>
      <path d="M1920,675.39l-16.41-44.89H1054.25l1,18h835.32L1911.27,703a89.67,89.67,0,0,0,8.73,17.47Z" transform="translate(0 -489.28)" style="fill:#b22025;fill-rule:evenodd"/>
      <path d="M1.05,901.39H1920v-140c-12.66-8.23-20.9-21.7-26.32-36.07l-21.83-57.8H45l-21.82,57.8C18.19,738.47,10.89,750.85,0,759.17V901.44C.35,901.41.69,901.39,1.05,901.39Z" transform="translate(0 -489.28)" style="fill:#c5c5c5"/>
      <path d="M1598.27,901.39,1460,550.53c-11-32.25-31.34-61.25-69.65-61.25H533c-38.31,0-58.62,29-69.66,61.25L325.05,901.39Z" transform="translate(0 -489.28)" style="fill:#548095;fill-rule:evenodd"/>
      <path d="M1.05,901.39H1920v-40H0v40.08C.35,901.41.69,901.39,1.05,901.39Z" transform="translate(0 -489.28)" style="fill:#c3d7df;fill-rule:evenodd"/>
      <path d="M392.18,642.26h1139c17.95,0,27.07,17.3,32.63,36.27L1625,887.28H298.3l61.25-208.75C365.12,659.56,374.24,642.26,392.18,642.26Z" transform="translate(0 -489.28)" style="fill:#586f7f;fill-rule:evenodd"/>
      <path d="M1920,816H1741a26.19,26.19,0,0,0-26.11,26.11v19.23H1920Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/>
      <path d="M171.07,816H0v45.34H197.18V842.12A26.19,26.19,0,0,0,171.07,816Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/>
      <rect x="374.63" y="29.73" width="15.06" height="114.69" style="fill:#ebebeb"/>
      <path d="M1380.87,605.05H542.67v-1.92c0-14.08,0-28.64-.94-38.17-.86-8.74-2.52-13.49-5.53-15.9-2.74-2.19-6.89-2.83-19.32-3-12.11-.14-31.82.15-50.88.43h-.5l-.06-3.84h.5c19.09-.27,38.83-.55,51-.42,12.66.13,17.84.73,21.68,3.8s6,8.53,6.95,18.52c.92,9.29,1,23.06,1,36.63H1377v-49l.23-.42c2.79-5.31,5.67-10.78,10.47-13.64s11-2.84,20.48-2.84h34.09v3.84H1408.2c-8.81,0-14.63,0-18.52,2.31s-6.24,6.8-8.81,11.7Z" transform="translate(0 -489.28)" style="fill:#36455c"/><rect x="476.26" y="29.73" width="15.06" height="114.69" style="fill:#ebebeb"/>
      <path d="M362,505.61h156a10.2,10.2,0,0,1,10.17,10.16h0a10.2,10.2,0,0,1-10.17,10.17H362a10.19,10.19,0,0,1-10.16-10.17h0A10.19,10.19,0,0,1,362,505.61Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/>
      <rect x="1442.29" y="27.63" width="15.51" height="114.69" style="fill:#ebebeb"/>
      <rect x="1546.95" y="27.63" width="15.51" height="114.69" style="fill:#ebebeb"/>
      <path d="M1413.6,503.51h163.93a10.2,10.2,0,0,1,10.17,10.16h0a10.2,10.2,0,0,1-10.17,10.17H1413.6a10.2,10.2,0,0,1-10.17-10.17h0A10.2,10.2,0,0,1,1413.6,503.51Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/>
      <rect x="343.2" y="133.53" width="1247.83" height="33.71" rx="16.85" style="fill:#ebebeb"/>
      <polygon points="518.71 398 526.71 372.07 553.89 284.07 387.07 284.07 331.73 284.07 305.9 372.07 298.3 398 348.08 398 518.71 398" style="fill:#ebebeb;fill-rule:evenodd"/>
      <polygon points="806.06 284.07 779.88 372.07 772.16 398 961.66 398 961.66 372.07 961.66 284.07 806.06 284.07" style="fill:#ebebeb;fill-rule:evenodd"/>
      <polygon points="1403.97 284.07 1403.97 372.07 1403.97 398 1575.24 398 1625.02 398 1617.41 372.07 1591.59 284.07 1536.25 284.07 1403.97 284.07" style="fill:#ebebeb;fill-rule:evenodd"/><path d="M191.09,825.4a26,26,0,0,1,6.09,16.72v19.23H305.91l10.55-36Z" transform="translate(0 -489.28)" style="fill:#052830;fill-rule:evenodd"/><path d="M1606.87,825.4l10.55,36h97.47V842.12A26,26,0,0,1,1721,825.4Z" transform="translate(0 -489.28)" style="fill:#052830;fill-rule:evenodd"/><polygon points="772.16 398 961.66 398 961.66 380.45 777.38 380.45 772.16 398" style="fill:#135e70;fill-rule:evenodd"/><polygon points="1403.97 380.45 1403.97 398 1575.24 398 1625.02 398 1619.87 380.45 1569.23 380.45 1403.97 380.45" style="fill:#135e70;fill-rule:evenodd"/><path d="M1660.29,789.67c-15.42,0-40.4-.15-64.57-.29l0-3.85c24.78.15,50.37.27,65.7.3,14.65,0,20-.19,22.1-2.26s2.13-7,2.22-17.8v-.53c.1-12,.29-30.83.49-49.7l3.84,0v.06c-.2,18.87-.39,37.72-.48,49.69v.53c-.1,12.29-.14,17.38-3.39,20.53s-8.92,3.34-24.77,3.34Z" transform="translate(0 -489.28)" style="fill:#d81f2b"/><path d="M1599.23,802v-3.84c59.94,0,121.92,0,154.43-.17,28.32-.14,35.64-.4,37.1-2.06,1.32-1.48,1.32-5.36,1.33-15.72V777c0-13.94.25-38.13.47-61.53l3.84,0c-.22,23.4-.44,47.58-.47,61.5v3.22c0,12,0,15.69-2.28,18.26-2.54,2.86-6.28,3.18-40,3.35C1721.17,802,1659.18,802,1599.23,802Z" transform="translate(0 -489.28)" style="fill:#d81f2b"/><path d="M1589.9,712.76l40.43-45.22H1560a114.52,114.52,0,0,1,3.78,11l27.83,94.82,15.27,52h46.87Z" transform="translate(0 -489.28)" style="fill:#121d38;fill-rule:evenodd;opacity:0.21"/><polygon points="1920 301.56 1882.66 301.41 1905.79 326.73 1920 326.73 1920 301.56" style="fill:#121d38;fill-rule:evenodd;opacity:0.21"/><polygon points="1920 326.73 1905.79 326.73 1920 342.29 1920 326.73" style="fill:#72818d;fill-rule:evenodd;opacity:0.21"/><polygon points="1920 356.2 1714.88 354.52 1714.88 372.07 1897.43 372.07 1920 372.07 1920 356.2" style="fill:#72818d;fill-rule:evenodd;opacity:0.21"/><polygon points="0 311.74 0 326.73 54.59 326.73 89.52 311.58 0 311.74" style="fill:#121d38;fill-rule:evenodd;opacity:0.36"/><polygon points="0 326.73 0 350.41 54.59 326.73 0 326.73" style="fill:#72818d;fill-rule:evenodd;opacity:0.36"/><polygon points="0 359.85 0 372.07 197.18 372.07 197.18 355.32 0 359.85" style="fill:#72818d;fill-rule:evenodd;opacity:0.36"/><path d="M262.65,789.67H261.5c-15.85,0-21.5-.17-24.77-3.34s-3.29-8.23-3.39-20.53v-.53c-.09-12-.29-30.82-.48-49.69l3.84-.1-1.92,0,1.92,0c.2,18.87.39,37.73.49,49.7v.53c.09,10.83.13,15.77,2.22,17.8s7.45,2.25,22.1,2.26c15.31,0,40.92-.15,65.69-.3l0,3.85C303.05,789.52,278.07,789.67,262.65,789.67Z" transform="translate(0 -489.28)" style="fill:#d81f2b"/><path d="M323.71,802c-59.95,0-121.94,0-154.46-.17-33.68-.17-37.42-.49-40-3.35-2.27-2.57-2.27-6.2-2.28-18.24V777c0-13.74-.25-37.56-.46-60.6v-.91l3.84,0v.92c.21,23,.43,46.87.46,60.63v3.23c0,10.35,0,14.22,1.32,15.7,1.47,1.66,8.79,1.92,37.11,2.06,32.51.17,94.49.17,154.43.17Z" transform="translate(0 -489.28)" style="fill:#d81f2b"/><path d="M307.73,722.25,277.6,825.4h38.86l15.27-52,19.92-67.89,7.9-26.93c1.11-3.77,2.35-7.47,3.78-11H275.76l5.13,8.77Z" transform="translate(0 -489.28)" style="fill:#121d38;fill-rule:evenodd;opacity:0.25"/><path d="M420,677l163.24,1.17,3.29-10.65,3.4-11h-221a67.44,67.44,0,0,0-5.61,11c-1.43,3.52-2.67,7.22-3.78,11l-7.9,26.93-4.6,15.69,13.46-12.4,34.65-31.9Z" transform="translate(0 -489.28)" style="fill:#121d38;fill-rule:evenodd;opacity:0.5"/><path d="M837.55,667.54,833.85,680l476.52,3.4V678h17.05v5.49h2.13V678h17v5.62l2.13,0V678h17v5.76l2.13,0V678h17v5.9h2.13V678h17.05v6l101.8.72,30.43.22,44.13,50.57-16.73-57a114.52,114.52,0,0,0-3.78-11,66.63,66.63,0,0,0-5.6-11H840.83Z" transform="translate(0 -489.28)" style="fill:#052830;fill-rule:evenodd;opacity:0.5"/><polygon points="331.73 284.07 1591.59 284.07 1588.89 274.88 334.42 274.88 331.73 284.07" style="fill:#e8f3fb;fill-rule:evenodd"/><path d="M989.65,719.61H1376a28.07,28.07,0,0,1,28,28V887.28H961.66V747.6A28.08,28.08,0,0,1,989.65,719.61Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><rect x="1052.79" y="297.42" width="172.81" height="83.36" style="fill:#4d4e4e"/><rect x="1244.91" y="282.79" width="131.13" height="102.06" style="fill:#135e70"/><rect x="1324.2" y="334.02" width="51.84" height="50.83" style="fill:#1a1a1a"/><rect x="1204.25" y="296.52" width="57.94" height="86.64" style="fill:#d81f2a"/><rect x="1007.04" y="295.19" width="82.34" height="88.63" style="fill:#d81f2a"/><path d="M995.43,762.31H1370.2a20,20,0,0,1,20,20v99.77H975.45V782.29A20,20,0,0,1,995.43,762.31Z" transform="translate(0 -489.28)" style="fill:#1ec2ed;fill-rule:evenodd;opacity:0.5"/><rect x="981.12" y="245.58" width="409.66" height="6.1" rx="3.05" style="fill:#1ec2ed"/><rect x="1147.72" y="279.73" width="70.18" height="9.49" rx="4.31" style="fill:#fff;opacity:0.5"/><polygon points="518.71 398 298.3 398 303.13 380.45 524.91 380.04 518.71 398" style="fill:#135e70;fill-rule:evenodd"/><path d="M381.32,747.06,358,835.42H436q11.37-44,22.73-88.1Z" transform="translate(0 -489.28)" style="fill:#36455c;fill-rule:evenodd"/><path d="M437.46,837.34H355.55l24.29-92.2,81.34.27Zm-76.93-3.84h74l21.73-84.26L382.8,749Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M403.83,747l-7.08,26.87h23.7q3.46-13.39,6.92-26.79Z" transform="translate(0 -489.28)" style="fill:#36455c;fill-rule:evenodd"/><path d="M421.94,775.81H394.26l8.09-30.73,27.5.09ZM399.24,772H419l5.92-23-19.58-.07Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><rect x="361.27" y="151.54" width="1204.91" height="8.01" style="fill:#d81f2b"/><rect x="1305.71" y="193.52" width="103.01" height="28.29" style="fill:#36455c"/><rect x="1310.37" y="193.52" width="17.05" height="24.05" style="fill:#d81f2a"/><rect x="1329.55" y="193.52" width="17.05" height="24.05" style="fill:#d81f2a"/><rect x="1348.73" y="193.52" width="17.05" height="24.05" style="fill:#d81f2a"/><path d="M271.15,682.89H49.55C42.28,705,35,727.08,27.94,741.78S14,763.81,7.59,768.55A46.45,46.45,0,0,1,0,773.15v11.4H50.34L77.3,702l211.29,2Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/><rect id="blinkLight" x="1367.91" y="193.52" width="17.05" height="24.05" style="fill:#d81f2a"/><rect x="1387.09" y="193.52" width="17.05" height="24.05" style="fill:#15a1c1"/><path d="M1920,779.4l-.37-.08a49.71,49.71,0,0,1-19.32-8.4c-6.57-4.75-13.62-12.07-20.87-26.77s-14.7-36.8-22.16-58.89H1630L1612.1,706.4l216.72-2q13.82,41.26,27.65,82.54H1920Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/><path d="M110.73,667.54h38v37.8a10.19,10.19,0,0,1-10.16,10.16H120.9a10.2,10.2,0,0,1-10.17-10.16Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><path d="M138.52,717.42H120.9a12.1,12.1,0,0,1-12.09-12.08V665.62H150.6v39.72A12.09,12.09,0,0,1,138.52,717.42Zm-25.87-48v35.88a8.26,8.26,0,0,0,8.25,8.24h17.62a8.25,8.25,0,0,0,8.24-8.24V669.46Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M129.71,686.78a5.93,5.93,0,1,0-5.72-5.93A5.84,5.84,0,0,0,129.71,686.78Z" transform="translate(0 -489.28)" style="fill:#d13d27;fill-rule:evenodd"/><path d="M129.71,688.7a7.85,7.85,0,1,1,7.64-7.85A7.76,7.76,0,0,1,129.71,688.7Zm0-11.86a4,4,0,1,0,3.8,4A3.91,3.91,0,0,0,129.71,676.84Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M217,667.54h38v37.8a10.19,10.19,0,0,1-10.16,10.16H227.21A10.2,10.2,0,0,1,217,705.34Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><path d="M244.83,717.42H227.21a12.1,12.1,0,0,1-12.09-12.08V665.62h41.79v39.72A12.09,12.09,0,0,1,244.83,717.42Zm-25.87-48v35.88a8.26,8.26,0,0,0,8.25,8.24h17.62a8.25,8.25,0,0,0,8.24-8.24V669.46Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M236,686.78a5.93,5.93,0,1,0-5.72-5.93A5.84,5.84,0,0,0,236,686.78Z" transform="translate(0 -489.28)" style="fill:#d13d27;fill-rule:evenodd"/><path d="M236,688.7a7.85,7.85,0,1,1,7.64-7.85A7.76,7.76,0,0,1,236,688.7Zm0-11.86a4,4,0,1,0,3.8,4A3.92,3.92,0,0,0,236,676.84Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M1669.19,667.54h38v37.8A10.19,10.19,0,0,1,1697,715.5h-17.62a10.2,10.2,0,0,1-10.17-10.16Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><path d="M1697,717.42h-17.62a12.1,12.1,0,0,1-12.09-12.08V665.62h41.79v39.72A12.09,12.09,0,0,1,1697,717.42Zm-25.86-48v35.88a8.25,8.25,0,0,0,8.24,8.24H1697a8.25,8.25,0,0,0,8.24-8.24V669.46Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M1688.17,686.78a5.93,5.93,0,1,0-5.72-5.93A5.84,5.84,0,0,0,1688.17,686.78Z" transform="translate(0 -489.28)" style="fill:#d13d27;fill-rule:evenodd"/><path d="M1688.17,688.7a7.85,7.85,0,1,1,7.64-7.85A7.76,7.76,0,0,1,1688.17,688.7Zm0-11.86a4,4,0,1,0,3.79,4A3.91,3.91,0,0,0,1688.17,676.84Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M1775.51,667.54h38v37.8a10.2,10.2,0,0,1-10.17,10.16h-17.62a10.19,10.19,0,0,1-10.16-10.16Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><path d="M1803.29,717.42h-17.62a12.1,12.1,0,0,1-12.09-12.08V665.62h41.8v39.72A12.1,12.1,0,0,1,1803.29,717.42Zm-25.86-48v35.88a8.25,8.25,0,0,0,8.24,8.24h17.62a8.25,8.25,0,0,0,8.24-8.24V669.46Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M1794.48,686.78a5.93,5.93,0,1,0-5.72-5.93A5.84,5.84,0,0,0,1794.48,686.78Z" transform="translate(0 -489.28)" style="fill:#d13d27;fill-rule:evenodd"/><path d="M1794.48,688.7a7.85,7.85,0,1,1,7.64-7.85A7.76,7.76,0,0,1,1794.48,688.7Zm0-11.86a4,4,0,1,0,3.8,4A3.91,3.91,0,0,0,1794.48,676.84Z" transform="translate(0 -489.28)" style="fill:#e4e4e4"/><path d="M358.11,722.27,320.7,856.45l22-13q16.26-56.12,32.53-112.23h109L450,849.13l62.62,1.63Q538.24,769,563.85,687.3L398,688.93Z" transform="translate(0 -489.28)" style="fill:#b3b3b3;fill-rule:evenodd;opacity:0.23"/><path d="M1920,859.22q-67.95,3.31-135.44,5.92c-65.7,2.52-131,4.49-196.5,6-232.71,5.4-467,5.15-725.15,4-172-.76-354.58-1.91-527.49-4.46C216.9,869,102.94,866.56,0,863.18v32H1920Z" transform="translate(0 -489.28)" style="fill:#a9dff3;fill-rule:evenodd;opacity:0.65"/><path d="M840.12,726.25c-8.4,26.71-23.58,75.5-38.76,124.29l141.5,3.25c1.08-39.84,2.17-79.69,4.07-102.46s4.6-28.46,8.67-32.66,9.49-6.92,15.18-8.82,11.66-3,65.87-2.84,156.68,1.49,259.14,2.85V692l-444-1.62C850.15,695,848.53,699.55,840.12,726.25Z" transform="translate(0 -489.28)" style="fill:#b3b3b3;fill-rule:evenodd;opacity:0.31"/><path d="M1417.78,696l1.62,156.14,179.72-.82c-14.36-42-28.73-84-41.2-109.78s-23-35.24-33.61-44.73Z" transform="translate(0 -489.28)" style="fill:#b3b3b3;fill-rule:evenodd;opacity:0.31"/><path d="M838.67,787.42a2.95,2.95,0,1,0-2.95-2.95A3,3,0,0,0,838.67,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M838.67,787.42a2.95,2.95,0,1,0-2.95-2.95A3,3,0,0,0,838.67,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M877.09,787.42a2.95,2.95,0,1,0-3-2.95A2.95,2.95,0,0,0,877.09,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M915.51,787.42a2.95,2.95,0,1,0-3-2.95A2.95,2.95,0,0,0,915.51,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M1455.54,787.42a2.95,2.95,0,1,0-3-2.95A2.95,2.95,0,0,0,1455.54,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M1455.54,787.42a2.95,2.95,0,1,0-3-2.95A2.95,2.95,0,0,0,1455.54,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M1494,787.42a3,3,0,1,0-2.94-2.95A2.95,2.95,0,0,0,1494,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M1532.37,787.42a3,3,0,1,0-2.94-2.95A2.95,2.95,0,0,0,1532.37,787.42Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M479.51,786.29a3,3,0,1,0-2.95-2.95A3,3,0,0,0,479.51,786.29Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M517.93,786.29a3,3,0,1,0-2.95-2.95A3,3,0,0,0,517.93,786.29Z" transform="translate(0 -489.28)" style="fill:#ace0f4;fill-rule:evenodd"/><path d="M632.75,656.51q-34.34,115.4-68.66,230.77H518.71Q554.34,771.9,590,656.51Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><polygon points="609.42 188.07 803.51 188.07 811.39 219.18 617.29 219.18 609.42 188.07" style="fill:#586f7f;fill-rule:evenodd"/><polygon points="600.38 218.44 794.48 218.44 802.35 249.55 608.26 249.55 600.38 218.44" style="fill:#899ca4;fill-rule:evenodd"/><polygon points="591.24 249.16 785.34 249.16 793.21 280.27 599.11 280.27 591.24 249.16" style="fill:#586f7f;fill-rule:evenodd"/><polygon points="582.1 279.89 776.19 279.89 784.07 311 589.97 311 582.1 279.89" style="fill:#899ca4;fill-rule:evenodd"/><polygon points="573.06 310.27 767.15 310.27 775.02 341.39 580.93 341.39 573.06 310.27" style="fill:#586f7f;fill-rule:evenodd"/><polygon points="798.05 167.24 632.75 167.24 629.47 178.26 626.55 188.07 791.61 188.07 794.64 178.26 798.05 167.24" style="fill:#052830;fill-rule:evenodd"/><polygon points="744.4 340.96 581.05 340.96 580.82 340.96 563.93 340.96 571.8 372.07 564.08 398 726.78 398 734.79 372.07 744.27 341.39 744.4 340.96" style="fill:#052830;fill-rule:evenodd"/><polygon points="563.93 340.96 758.02 340.96 765.89 372.07 571.8 372.07 563.93 340.96" style="fill:#899ca4;fill-rule:evenodd"/><path d="M840.83,656.51,772.16,887.28H726.79q35.63-115.38,71.26-230.77Z" transform="translate(0 -489.28)" style="fill:#135e70;fill-rule:evenodd"/><path d="M591.32,652.34,518.71,887.28h15l72.6-235.76Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/><path d="M799,652.08l-72.18,235.2h15.05q36.35-117.87,72.7-235.76Z" transform="translate(0 -489.28)" style="fill:#ebebeb;fill-rule:evenodd"/><path d="M609.43,677.35v-4.69H793.21q-.74,2.34-1.45,4.68Z" transform="translate(0 -489.28)" style="fill:#fff;fill-rule:evenodd"/><path d="M600.39,707.72V703H784.17c-.48,1.56-1,3.12-1.45,4.68Z" transform="translate(0 -489.28)" style="fill:#fff;fill-rule:evenodd"/><path d="M591.25,738.44v-4.68H775c-.49,1.56-1,3.11-1.45,4.67Z" transform="translate(0 -489.28)" style="fill:#fff;fill-rule:evenodd"/><path d="M582.1,769.17v-4.69H765.88l-1.44,4.68Z" transform="translate(0 -489.28)" style="fill:#fff;fill-rule:evenodd"/><path d="M573.06,799.55v-4.68H756.84l-1.44,4.67Z" transform="translate(0 -489.28)" style="fill:#fff;fill-rule:evenodd"/><path d="M563.93,830.24v-4.68H747.71c-.48,1.56-1,3.11-1.45,4.67Z" transform="translate(0 -489.28)" style="fill:#fff;fill-rule:evenodd"/><rect x="1251.43" y="108.5" width="6.91" height="13.62" rx="2.44" style="fill:#1ec2ed"/><rect x="1250.99" y="106.87" width="7.78" height="13.62" rx="2.75" style="fill:#36455c"/><rect x="1274.48" y="108.5" width="6.91" height="13.62" rx="2.44" style="fill:#1ec2ed"/><rect x="1274.04" y="106.87" width="7.78" height="13.62" rx="2.75" style="fill:#36455c"/><rect x="629.03" y="108.5" width="6.91" height="13.62" rx="2.44" style="fill:#1ec2ed"/><rect x="628.59" y="106.87" width="7.78" height="13.62" rx="2.75" style="fill:#36455c"/><rect x="652.08" y="108.5" width="6.91" height="13.62" rx="2.44" style="fill:#1ec2ed"/><rect x="651.65" y="106.87" width="7.78" height="13.62" rx="2.75" style="fill:#36455c"/><polygon points="1746.03 412.11 1625.02 398 298.3 398 216.61 412.11 1746.03 412.11" style="fill-rule:evenodd;opacity:0.5"/><rect x="1300.11" y="307.33" width="11.13" height="19.48" rx="3.93" style="fill:#196f83"/><rect x="1333.07" y="307.33" width="11.13" height="19.48" rx="3.93" style="fill:#196f83"/><rect x="1023.98" y="307.23" width="11.13" height="19.48" rx="3.93" style="fill:#196f83"/><rect x="1056.95" y="307.23" width="11.13" height="19.48" rx="3.93" style="fill:#196f83"/><rect x="933.59" y="84.11" width="49.62" height="49.42" style="fill:url(#linear-gradient)"/></svg>
     <svg id="Mouse_Droid" data-name="Mouse Droid" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 67.77 37.88"><defs><clipPath id="clip-path" transform="translate(-1085.81 -584.21)"><path d="M1151.43,602.36H1088a1.26,1.26,0,0,1-.91-2.12l12.18-12.88a1.26,1.26,0,0,1,.91-.39h39.11a1.23,1.23,0,0,1,.91.39l12.18,12.88A1.26,1.26,0,0,1,1151.43,602.36Z" style="fill:none;clip-rule:evenodd"/></clipPath></defs><rect x="1.97" y="17.07" width="63.83" height="4.55" style="fill:#586f7f"/><path d="M1086,605.53l5,8.94a1.09,1.09,0,0,0,.95.55h2.94a9.2,9.2,0,0,1,18.4,0h13a9.2,9.2,0,0,1,18.39,0h2.94a1.08,1.08,0,0,0,1-.55l5-8.94a1.09,1.09,0,0,0-1-1.62h-65.6A1.09,1.09,0,0,0,1086,605.53Z" transform="translate(-1085.81 -584.21)" style="fill:#c5c5c5"/><path d="M1104,605.83a9.19,9.19,0,0,0-9.2,9.19h18.4A9.19,9.19,0,0,0,1104,605.83Z" transform="translate(-1085.81 -584.21)" style="fill:#586f7f"/><path d="M1135.39,605.83a9.19,9.19,0,0,0-9.2,9.19h18.39A9.18,9.18,0,0,0,1135.39,605.83Z" transform="translate(-1085.81 -584.21)" style="fill:#586f7f"/><circle id="rlight" cx="33.65" cy="4.28" r="4.28" style="fill:#d81f2b"/><circle cx="18.2" cy="30.82" r="7.06" style="fill:#052830"/><circle cx="18.2" cy="30.82" r="1.88" style="fill:#36455c"/><circle cx="49.58" cy="30.82" r="7.06" style="fill:#052830"/><circle cx="49.58" cy="30.82" r="1.88" style="fill:#36455c"/><g style=""><path d="M1151.43,602.36H1088a1.26,1.26,0,0,1-.91-2.12l12.18-12.88a1.26,1.26,0,0,1,.91-.39h39.11a1.23,1.23,0,0,1,.91.39l12.18,12.88A1.26,1.26,0,0,1,1151.43,602.36Z" transform="translate(-1085.81 -584.21)" style="fill:#c5c5c5;fill-rule:evenodd"/><polyline points="7.84 8.79 21.77 8.79 21.77 13.37 48.92 13.37 58.97 7.49" style="fill:none;stroke:#586f7f;stroke-miterlimit:10;fill-rule:evenodd"/><polyline points="5.76 9.35 21.49 9.35 21.49 13.93 48.92 13.93 58.97 8.04" style="fill:none;stroke:#ebebeb;stroke-miterlimit:10;fill-rule:evenodd"/></g><path d="M33.4,25h.49a1.78,1.78,0,0,1,1.78,1.78v4.06a0,0,0,0,1,0,0h-4a0,0,0,0,1,0,0V26.76A1.78,1.78,0,0,1,33.4,25Z" style="fill:#586f7f"/></svg>
      
    <article class="md:w-1/3 login-article mx-auto">
      <header>
        <h2 class="text-center">Student: Login</h2>
      </header>
      <transition name="fade">
        <p
          class="bg-red-100 p-5 my-5 border border-red-200 rounded text-red-500"
          v-if="error"
        >
          {{ error }}
        </p>
      </transition>
      <form @submit.prevent>
        <!--<div class="mb-4">
          <label for="CODE" class="font-bold align-center text-gray-700">Code: </label>
          <input
            type="text"
            v-if="isRegistration"
            placeholder="registration code from your teacher"
            v-model="classroomCode"
            id="code"
            class="bg-white px-4 py-2 border rounded w-full"
          />
        </div>-->
        <div class="mb-4">
          <label for="email" class="font-bold text-gray-700">Email: </label>
          &nbsp;
          &nbsp;
          &nbsp;
          <input
            type="email"
            placeholder="joe@bloggs.com"
            v-model="email"
            id="email"
            class="bg-white px-4 py-2 border rounded w-full"
          />
        </div>
        <div class="mb-4">
          <label class="label">Password: </label>
          &nbsp;
          &nbsp;
          &nbsp;
          <input
            type="password"
            v-model="password"
            id="password"
            class="bg-white px-4 py-2 border rounded w-full"
          />
        </div>
        <b-button
          type="submit"
          @click="onSubmit"
          class="neu-button rounded border transition duration-500 ease-in-out hover:bg-green-600"
        >
          Launch
        </b-button>
      </form>
        <router-link :to="{ name: 'forgotPassword' }" class="hover:underline"
            >Forgot password</router-link
          >
    </article>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import classroomMixin from '../../shared_methods/classroomMixin'
export default {
  name: 'registerr',
  mixins: [classroomMixin],

  props: {
    isStudent: Boolean,
    isEducator: Boolean
  },
  computed: {
    getAuthType() {
      return this.isRegistration ? 'Finalize Your Profile' : 'Login'
    },
    getAuthTypeButtonLabel() {
      return this.isRegistration ? 'Your Profile' : "Let's Launch"
    },
    isRegistration() {
      return this.$route.name === 'SignUp'
    },
    routeAuthentication() {
      return this.isRegistration
        ? '/register'
        : '/login'
    }
  },
data() {
    return {
      email: null,
      isPwd: true,
      password: null,
      givenName: null,
      familyName: null,
      passwordMatch: null,
      classroomCode: null,
      invalidCode: true,
      classroomInfo: {
        classroomid: '',
        creatorid: ''
      },
      role: 'student',
      error:null
    }
  },
 methods: {
    ...mapActions('auth', ['createNewUser','latestLogin', 'loginUser']),
   async onSubmit()  {
      const { email, password } = this
   //   this.$refs.emailAuthenticationForm.validate().then(async (success) => {
     //   if (success) {
         // this.$q.loading.show({
        //    message: this.isRegistration
       //       ? 'Registering your account...'
        //      : 'Authenticating your account...',
       //     backgroundColor: 'grey',
       //     spinner: QSpinnerGears,
      //      customClass: 'loader'
     //     })
    // console.log(success)
          try {
            console.log(this.familyName)
            const userInfo = {
              state: this.state,
              email: this.email,
              role: this.role,
              password: this.password,
              schoolName: this.schoolName,
              familyName: this.familyName,

              classroom: this.classroomInfo.classroomid,
              givenName: this.givenName
            }

            console.log(this.isRegistration)
            if (this.isRegistration) {
              await this.createNewUser(userInfo)
            } else {
              await this.loginUser({ email, password })
            }
          } catch (err) {
            this.error=err
          //  this.$q.notify({
         //     message: `An error as occured: ${err}`,
         //     color: 'negative'
         //   })
          } finally {
            console.log(this)
           
            this.$router.push({ path: '/' })
          }
      //  }
     // })
    },
    async getClassroomInfo() {
      //this.classInfo.name
      var info = await this.getClassroomInfoFromCode(this.classroomCode)
      console.log(info)
      console.log(info.length)
      if (info.length == 0) {
        this.$q.notify({
          message: `please enter a valid code`,
          color: 'negative'
        })
        this.invalidCode = true
      } else {
        console.log(info[0])
        this.classroomInfo.classroomid = info[0].classroom
        this.classroomInfo.creatorid = info[0].creatorid

        this.invalidCode = false
      }
    }
  }

};
</script>
<style scoped>
input {
    width: 26vw;
    /* text-align: right; */
    float: right;
}
.p-5 {
    margin: -15px 0px 9px !important;
    padding: 0px !important;
    color:#de1a21;
}
.neu-button {
    border: 0px solid white;
    width: 100%;
    margin-top: 5vh;
    margin-bottom:10px;
    height: 7vh;
    border-radius: 150px;
    background: rgba(0,0,0,0);
    box-shadow: 6px 6px 12px #b8b9be, -6px -6px 12px #fff;
    line-height: 14px;
    display: flex;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif !important;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    color: #de1a21 !important;
    font-size: 1em;
    text-transform: uppercase;

}
.signup-landing header {
    margin-bottom: 4vh;
}
.login-article {
    position: absolute;
    background-color: white;
    padding: 8vh 7vw;
    z-index: 999;
    width: 50vw;
    border: 4px solid red;
    top: 127px;
    height: 53vh;
    left: 25vw;
    border-radius: 2vw;
}
.signup-landing{
  background-color: white;
}
svg {
  height: 95vh;
  width: 100vw; 
}


#Mouse_Droid #rLight{
  animation: animLight 1s linear infinite;
}

#blinkLight{
  animation: animLight 3s linear infinite;
}

@keyframes animLight {
  0% { opacity: 1; }
  10% { opacity: 1; }
  15% { opacity: 0; }
  100% { opacity: 0; }
}

/* ============================================================================================== 
SED Innovations
https://sed.am
https://mkrtchyan.ga
================================================================================================= */


@keyframes move-twink-back {
    from {background-position:0 0;}
    to {background-position:-10000px 5000px;}
}
@-webkit-keyframes move-twink-back {
    from {background-position:0 0;}
    to {background-position:-10000px 5000px;}
}
@-moz-keyframes move-twink-back {
    from {background-position:0 0;}
    to {background-position:-10000px 5000px;}
}
@-ms-keyframes move-twink-back {
    from {background-position:0 0;}
    to {background-position:-10000px 5000px;}
}

@keyframes move-clouds-back {
    from {background-position:0 0;}
    to {background-position:10000px 0;}
}
@-webkit-keyframes move-clouds-back {
    from {background-position:0 0;}
    to {background-position:10000px 0;}
}
@-moz-keyframes move-clouds-back {
    from {background-position:0 0;}
    to {background-position:10000px 0;}
}
@-ms-keyframes move-clouds-back {
    from {background-position: 0;}
    to {background-position:10000px 0;}
}

.stars, .twinkling, .clouds {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  width:100%;
  height:100%;
  display:block;
}

.stars {
  background:#000 url(http://www.script-tutorials.com/demos/360/images/stars.png) repeat top center;
  z-index:0;
}

.twinkling{
  background:transparent url(http://www.script-tutorials.com/demos/360/images/twinkling.png) repeat top center;
  z-index:1;

  -moz-animation:move-twink-back 400s linear infinite;
  -ms-animation:move-twink-back 400s linear infinite;
  -o-animation:move-twink-back 400s linear infinite;
  -webkit-animation:move-twink-back 400s linear infinite;
  animation:move-twink-back 400s linear infinite;
}

.clouds{
    background:transparent url(http://www.script-tutorials.com/demos/360/images/clouds3.png) repeat top center;
    z-index:3;
    opacity: 0.5;
  -moz-animation:move-clouds-back 200s linear infinite;
  -ms-animation:move-clouds-back 200s linear infinite;
  -o-animation:move-clouds-back 200s linear infinite;
  -webkit-animation:move-clouds-back 200s linear infinite;
  animation:move-clouds-back 200s linear infinite;
}

@keyframes animDroid {
  0% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(700px);
  }
  100% {
    transform: translateX(0px);
  }
}


svg#Foreground {
    position: absolute;
    left: 0;
    bottom: -28vh;
    z-index: 5;
}

svg#Background {
    position: absolute;
    left: 0;
    top: 1vh;
    z-index: 4;
}

svg#Logo_Carousel {
    position: absolute;
    left: 0;
    top: -38vh;
    z-index: 6;
}

#shipTube {
    z-index: 999;
    position: absolute;
    left: 29.6vw;
    top: 26vh;
     border: 10px solid white;
    border-radius: 5px;
}

#Mouse_Droid {
    z-index: 9999;
    position: absolute;
    left: 25.6vw;
    top: 67vh;
    width: 6vw !important;
    height: 6vh !important;
    animation: animDroid 50s linear infinite;
}

@media only screen and (max-width:600px){
   .twinkling, .clouds, .stars{
    display: none !important;
  }
}

@media only screen and (max-width:960px){
  input{
    width: 54vw;
  }
  .login-article{
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0vw;
    z-index: 999999999999999999;

  }
  #shipTube {
    width: 82vw;
    left: 9vw !important;
    top: 28vh !important;
    height: 22vh;
}
.swiper-container {
    width: 30vw !important;
    height: 10vh !important;

}
.swiper-slide {
    width: 30vw !important;
    margin-right: 11vw;
}
.sponsorLogos .row {
  display: block !important;
}
.col {
    flex-basis: 0;
    flex-grow: 1;
    width: 50% !important;
    float: left !important;
    margin-bottom: 10px;
}
} 
</style>